import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=0c4b5d17"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4b5d17')) {
      api.createRecord('0c4b5d17', component.options)
    } else {
      api.reload('0c4b5d17', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=0c4b5d17", function () {
      api.rerender('0c4b5d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/users/Users.vue"
export default component.exports